import FontesACadastrarService from "../../../services/http/services/SaldoDeContas/FontesACadastrarService";

export const getQuantidadesFontesACadastrarSaldoDeContas = async () => {
    try {
        const response = await FontesACadastrarService.getQuantidadeFontesACadastrar();
        return response;
    } catch (error: any) {
        return null;
    }
};
